import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useContext } from 'react';
import { ThemeProvider } from 'styled-components';
import { KeyboardDetectionContext } from "../../contexts/KeyboardDetectionContext";
import { Link } from "./Link";
var TextLinkComponent = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? {} : _ref$theme,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["theme", "children"]);

  var _useContext = useContext(KeyboardDetectionContext),
      isUsingKeyboard = _useContext.isUsingKeyboard;

  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Link, Object.assign({
    isUsingKeyboard: isUsingKeyboard
  }, props, {
    ref: ref
  }), children));
});
TextLinkComponent.defaultProps = {
  textColor: 'inherit'
};
var textLinkHelpers = {
  darkTheme: {
    textLink: 'dark'
  }
};
export var TextLink = Object.assign(TextLinkComponent, textLinkHelpers);
export default TextLink;